import { Card } from "antd";

interface Props {
  data: any;
}

export default function DetailsTemplateParagraph({ data }: Props) {
  return (
    <>
      <Card className="mt-4">
        <div className="self-stretch justify-start text-zinc-700 text-base font-medium">
          {data?.question_title}
        </div>
        <div className="w-full mt-4 h-11 py-2.5 bg-white border-b border-slate-400 inline-flex justify-start items-center gap-2.5 overflow-hidden">
          <div className="justify-start text-slate-400 text-sm font-medium">
            {data?.answer ? data?.answer : "Your short answer"}
          </div>
        </div>
      </Card>
    </>
  );
}
